import React from "react";

import { faTimes, faTimesCircle } from "@awesome.me/kit-4c83d50d0d/icons/classic/light";
import { faUser } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cx from "classnames";

import styles from "./Input.module.css";

type InputProps = React.HTMLProps<HTMLInputElement> &
	React.InputHTMLAttributes<HTMLInputElement> & {
		error?: boolean;
		onClear?: () => void;
		onRemove?: () => void;
		profile?: boolean;
	};

export default function Input({ className, error, onClear, onRemove, profile, value, ...rest }: InputProps) {
	return (
		<div className={styles.inputContainer}>
			{profile && (
				<span className={styles.profileIcon}>
					<FontAwesomeIcon icon={faUser} />
				</span>
			)}
			<input
				value={value}
				{...rest}
				className={cx(styles.input, className, { [styles.error]: error, [styles.profile]: profile })}
			/>
			{value && onClear && (
				<span className={styles.clearInput} onClick={onClear}>
					<FontAwesomeIcon icon={faTimesCircle} />
				</span>
			)}
			{!value && onRemove && (
				<span className={styles.removeInput} onClick={onRemove}>
					<FontAwesomeIcon icon={faTimes} />
				</span>
			)}
		</div>
	);
}
